var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcEMandate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 48,
    viewBox: "0 0 80 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5077_43123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_5077_43123)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M74 0H6C2.68629 0 0 2.68629 0 6V42C0 45.3137 2.68629 48 6 48H74C77.3137 48 80 45.3137 80 42V6C80 2.68629 77.3137 0 74 0Z",
    fill: "#F6F8FA"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.3046 18.7104C52.0995 18.9155 51.8213 19.0308 51.5312 19.0308H50.4375V33.2495H52.625V35.437H26.375V33.2495H28.5625V19.0308H27.4688C27.1787 19.0308 26.9005 18.9155 26.6954 18.7104C26.4902 18.5053 26.375 18.2271 26.375 17.937V14.6558C26.3751 14.431 26.4444 14.2117 26.5736 14.0277C26.7028 13.8438 26.8855 13.7041 27.0969 13.6277L39.1281 9.25266C39.3684 9.16578 39.6316 9.16578 39.8719 9.25266L51.9031 13.6277C52.1145 13.7041 52.2972 13.8438 52.4264 14.0277C52.5556 14.2117 52.6249 14.431 52.625 14.6558V17.937C52.625 18.2271 52.5098 18.5053 52.3046 18.7104ZM39.5 11.4402L28.5625 15.4214V16.8433H50.4375V15.4214L39.5 11.4402ZM37.3125 19.0308V33.2495H41.6875V19.0308H37.3125ZM35.125 19.0308H30.75V33.2495H35.125V19.0308ZM43.875 33.2495H48.25V19.0308H43.875V33.2495ZM24.1875 39.8121V37.6246H54.8125V39.8121H24.1875Z",
    fill: "#4776E6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5077_43123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 48,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_5077_43123"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcEMandate);
export default __webpack_public_path__ + "static/media/ic-e-mandate.5c7c29bfe6bc2900bf09d4014751b51a.svg";
export { ForwardRef as ReactComponent };